import React from 'react';
import './showLoading.less';
class ShowLoading extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            skin: props.skin ? props.skin : "",
        };
    }

    render() {
        let isLoading = this.props.isLoading;
        let isShade = this.props.isShade ? true : false;
        let isStopOperate = this.props.isStopOperate ? true : false;
        let isTitle=this.props.title?true:false;
        let title=this.props.title;
        let hasBorder=this.props.hasBorder;
        let fullCenter=this.props.fullCenter?true:false;
        let elems = null;
        elems = isLoading ?
            // <div className="myShowLoading">
            //     <div className="myShowLoading-content">
            //         <img src="https://dgjapp.com/public/images/zhipoIcon/timg02.gif" />
            //         <span className="myShowLoading-title">加载中<i class="ani_dot">...</i></span>
            //     </div>
            // </div> 
            isShade ?
                <div className={fullCenter?"myShowLoading fullCenter":"myShowLoading"}  >
                    <div className={hasBorder?"next-loading-tip hasBorder":"next-loading-tip"}>
                        <div className="next-loading-fusion-reactor">
                            <span className="next-loading-dot"></span>
                            <span className="next-loading-dot"></span>
                            <span className="next-loading-dot"></span>
                            <span className="next-loading-dot"></span>
                        </div>
                        {isTitle?<div className="next-loading-fusion-title">{title}</div>:null}
                    </div>
                </div> :
                isStopOperate ?
                    <div className={fullCenter?"myShowLoading fullCenter isOperate":"myShowLoading isOperate"}>
                        <div className={hasBorder?"next-loading-tip hasBorder":"next-loading-tip"}>
                            <div className="next-loading-fusion-reactor">
                                <span className="next-loading-dot"></span>
                                <span className="next-loading-dot"></span>
                                <span className="next-loading-dot"></span>
                                <span className="next-loading-dot"></span>
                            </div>
                            {isTitle?<div className="next-loading-fusion-title">{title}</div>:null}
                        </div>

                    </div>
                    :
                    <div className={hasBorder?"next-loading-tip hasBorder":"next-loading-tip"}>
                        <div className="next-loading-fusion-reactor">
                            <span className="next-loading-dot"></span>
                            <span className="next-loading-dot"></span>
                            <span className="next-loading-dot"></span>
                            <span className="next-loading-dot"></span>
                        </div>
                        {isTitle?<div className="next-loading-fusion-title">{title}</div>:null}
                    </div>
            : null
        return (
            elems
        );
    }
}

export default ShowLoading;



// WEBPACK FOOTER //
// ./src/components/showLoading/showLoading.jsx